   jQuery(document).ready(function(){
        jQuery('.thb-client-row .row').addClass('owl-carousel');
        jQuery('.thb-client-row .row').owlCarousel({
              loop: true,
              dots:true, 
              nav:false,
              touchDrag:true,
              mouseDrag:true, 
              autoplay: true, 
              smartSpeed: 1000,
              items:4,
              responsive: {
                    
                    0: {
                      items:2
                    },
                    568:{
                        items:3
                    },
                    768: {
                      items:3
                    },
                    992: {
                      items:3, autoplay: false, 
                    },
                    1000: {
                      items:5
                    }
                   
              }
         })
});

if(jQuery( window ).width() < 800){


  jQuery(document).ready(function(){
        jQuery('.top-food-products .multicolumn .row').addClass('owl-carousel');
        jQuery('.top-food-products .multicolumn .row').owlCarousel({
              loop: true,
              dots:false, 
              nav:false,
              touchDrag:true,
              mouseDrag:true, 
              autoplay: true, 
              // stagePadding: 60,
              smartSpeed: 1000,
              items:4,
              responsive: {
                    
                    0: {
                      items:1, stagePadding: 100
                    },
                    568:{
                        items:2, stagePadding: 60
                    },
                    768: {
                      items:3,  stagePadding: 60
                    },
                    992: {
                      items:4,  stagePadding: 60
                    }
                   
              }
         })
          });
}

jQuery(document).ready(function() {
  jQuery(".faq_block .fq_title").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".fq_content")
        .slideUp(200);
    } else {
    jQuery(".faq_block .fq_title").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".fq_content").slideUp(200);
      jQuery(this)
        .siblings(".fq_content")
        .slideDown(200);
    }
  });
});
setTimeout(function() {
  jQuery( ".jdgm-rev__header .jdgm-row-profile" ).each(function(){
    jQuery( this ).appendTo(jQuery(this).parents('.jdgm-divider-top').find('.jdgm-rev__content'));
  })
   jQuery('.product-information .star-rating-container').appendTo('.product-information .product-price-container');
  jQuery(".jdgm-rev__author").append('<p class="verifield_buy">Verified Buyer </p>');
  jQuery('.jdgm-rev-widg__title').html('<strong>100%</strong> would recommend this product');
  jQuery('.jdgm-rev-widg__header').append('<div class="rev_tab"><strong>Reviews</strong></div>')
}, 500); 
setTimeout(function() {
  jQuery('.jdgm-widget-actions-wrapper').prependTo('.jdgm-row-actions');
   jQuery('.jdgm-rev-widg__title').appendTo('.jdgm-row-stars');
}, 1000); 

// setTimeout(function() {
//         jQuery( ".jdgm-rev-widg__sort-wrapper " ).append( jQuery( ".jdgm-widget-actions-wrapper" ) );
// }, 500);

jQuery(".recipe_metasec .rich-text").each(function(){if(jQuery(this).text().trim()=='') jQuery(this).parent().hide();})